import {computed, _} from '@api'
import {CatalogInstanceChildStore, CatalogStore} from '@stores/catalog'
import {LibraryItemConfigWrapper} from '@stores/catalog/LibraryItemConfigWrapper'
import {ICatalogFieldConfig, WorkspaceConfig} from '@stores/config'
import {computedFn} from 'mobx-utils'

/**
 *
 *
 * Example for Gant:
 *
 * MPV Workspace
 *    Link to Style (Article)
 *        Link to Colorway
 * Article Workspace
 *    Link to Colorway
 * Colorway Workspace
 *
 *
 * So...
 *
 *  MPV uses Style, Colorway, Material
 *  Style uses Colorway and is used by MPV
 *  Colorway is used by Style and MPV
 */
export class CatalogRelationshipsStore extends CatalogInstanceChildStore
{
  constructor(public catalog : CatalogStore) {
    super(catalog)
  }

  @computed get otherWorkspaceFieldsThatReferToThisWorkspace() {
    return this.otherWorkspaceFieldsThatReferTo(this.catalog.workspaceConfig)
  }

  @computed get librariesWithWorkspaces() {
    return this.librariesWithWorkspacesFor(this.catalog.workspaceConfig)
  }
  
  get libraries() {
    return this.catalog.libraries
  }

  otherWorkspaceFieldsThatReferTo = computedFn((workspace: Partial<WorkspaceConfig>) : { [workspaceId: string]: Array<ICatalogFieldConfig> } => {
    const {availableWorkspaces} = this.workspaces

    if (!workspace) { return {} }

    return availableWorkspaces.filter(v => v._id != workspace._id).reduce(
      (acc, ws) => {
        const fieldsReferencingUs = (ws.catalog?.fields ?? []).filter(f => f.esIndex === workspace.catalog?.index)
        return _.isEmpty(fieldsReferencingUs) ? acc : {...acc, [ws._id]: fieldsReferencingUs}
      }, {})
  })

  librariesWithWorkspacesFor = computedFn((ws: Partial<WorkspaceConfig>) => {
    const libraries = this.librariesOfWorkspace(ws)
    return libraries.filter(({config: {index}}) => index && this.workspaces.byIndexScalar[index])
  })

  librariesOfWorkspace = computedFn((workspace: Partial<WorkspaceConfig>) : Array<LibraryItemConfigWrapper> => {
    return this.workspaces.librariesOfWorkspace(this.catalog, workspace)
  })

  fieldsRelatedToLibraryForWorkspace = computedFn((workspace: Partial<WorkspaceConfig>, libraryName: string) => {
    const l = this.librariesOfWorkspace(workspace).find(l => l.config.name === libraryName)
    if (!l) return []

    const r = (workspace.catalog?.fields ?? []).filter(f => f.esIndex === l.config.index)
    return _.orderBy(r, f => this.workspaces.workspaceFor(workspace._id).catalog.labelForField(f))
  })
}


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogRelationshipsStore.ts